<template>
  <div>
    <CompanyAboutUs/>
    <CompanyServices/>
    <CompanyTeam/>
    <CompanyPartners/>
    <CompanyPrinciples/>
    <CompanyContact/>
  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted} from 'vue';
import CompanyAboutUs from './CompanyAboutUs.vue';
import CompanyServices from './CompanyServices.vue';
import CompanyTeam from './CompanyTeam.vue';
import CompanyPartners from './CompanyPartners.vue';
import CompanyContact from "@/components/CompanyContact.vue";
import CompanyPrinciples from "@/components/CompanyPrinciples.vue";

export default defineComponent({
  name: 'HomePage',
  components: {
    CompanyPrinciples,
    CompanyAboutUs,
    CompanyServices,
    CompanyTeam,
    CompanyPartners,
    CompanyContact
  },
  setup() {
    onMounted(() => {
      if (!window.location.hash) {
        window.location.hash = '#about';
      }
    });
  },
});
</script>
